import React from 'react';
import { Dropdown } from 'primereact/dropdown';

import { useFileManagerContext } from 'modules/FileManagerV2/context/FileManagerContext';
import { signatureStatusOptions } from 'modules/FileManagerV2/constants/fileManagerConstants';

function SignatureStatusFilter() {
  const { fileManagerFilters, onFilterChange, setSelectedRows } = useFileManagerContext();

  const handleSignatureStatusChange = (e) => {
    onFilterChange({
      target: { name: 'esignature_status', value: e.value },
      value: e.value,
    });
    setSelectedRows([]);
  };

  return (
    <Dropdown
      options={signatureStatusOptions}
      value={fileManagerFilters?.esignature_status}
      placeholder="All Types"
      className="file-manager-select w-100"
      onChange={handleSignatureStatusChange}
      name="esignature_status"
    />
  );
}

export default SignatureStatusFilter;
